export const enum ModalTypes {
  alert = 'alert',
  confirm = 'confirm',
  prompt = 'prompt',
  password = 'password',
  default = 'default',
  form = 'form',
  forceChoice = 'forceChoice'
}

export const enum UsageTypes {
  Beginner = 1,
  Prototyper,
  Advance,
  Production
}